import { Node, mergeAttributes } from '@tiptap/core'

/**
 * Node customizado para preservar spans com classes específicas
 * Mantém classes como 'pagenum' e outros atributos importantes
 */
export const CustomSpanNode = Node.create({
    name: 'customSpan',
    group: 'inline',
    inline: true,
    atom: true,

    addAttributes() {
        return {
            class: {
                default: null,
                parseHTML: element => element.getAttribute('class'),
                renderHTML: attributes => attributes.class ? { class: attributes.class } : {},
            },
            style: {
                default: null,
                parseHTML: element => element.getAttribute('style'),
                renderHTML: attributes => attributes.style ? { style: attributes.style } : {},
            },
            textContent: {
                default: '',
                parseHTML: element => element.textContent || element.innerHTML,
                renderHTML: () => ({}),
            },
        }
    },

    parseHTML() {
        return [{
            tag: 'span',
            getAttrs: element => ({
                class: element.getAttribute('class'),
                style: element.getAttribute('style'),
                textContent: element.textContent || element.innerHTML,
            }),
        }];
    },

    renderHTML({ node, HTMLAttributes }) {
        const attrs = {};
        if (node.attrs.class) attrs.class = node.attrs.class;
        if (node.attrs.style) attrs.style = node.attrs.style;

        return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, attrs), node.attrs.textContent || ''];
    },
});